export function generateStervalHarvestParams(device) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    console.log(device);
    const params = {
        device: {
            end_device: {
                ids: {
                    device_id: device.id,
                    //@ts-ignore
                    dev_eui: (_a = device.additionalParams) === null || _a === void 0 ? void 0 : _a.deviceEUI,
                    //@ts-ignore
                    dev_addr: (_b = device.additionalParams) === null || _b === void 0 ? void 0 : _b.deviceEUI.slice(8, 16),
                },
                //@ts-ignore
                network_server_address: `${(_c = device.additionalParams) === null || _c === void 0 ? void 0 : _c.deviceMac}.cloud.thethings.network`,
                //@ts-ignore
                application_server_address: `${(_d = device.additionalParams) === null || _d === void 0 ? void 0 : _d.deviceMac}.cloud.thethings.network`,
                //@ts-ignore
                join_server_address: `${(_e = device.additionalParams) === null || _e === void 0 ? void 0 : _e.deviceMac}.cloud.thethings.network`,
                name: device.label,
                description: `${device.label} ${new Date().toISOString()}`,
            },
            field_mask: {
                paths: [
                    "name",
                    "description",
                    "network_server_address",
                    "application_server_address",
                    "join_server_address",
                ],
            },
        },
        joinServer: null,
        networkServer: {
            end_device: {
                ids: {
                    device_id: device.id,
                    //@ts-ignore
                    dev_eui: (_f = device.additionalParams) === null || _f === void 0 ? void 0 : _f.deviceEUI,
                    //@ts-ignore
                    dev_addr: (_g = device.additionalParams) === null || _g === void 0 ? void 0 : _g.deviceEUI.slice(8, 16),
                },
                supports_join: false,
                //@ts-ignore
                lorawan_phy_version: (_h = device.additionalParams) === null || _h === void 0 ? void 0 : _h.loraWANPHYVersion,
                //@ts-ignore
                lorawan_version: (_j = device.additionalParams) === null || _j === void 0 ? void 0 : _j.loraWANVersion,
                //@ts-ignore
                frequency_plan_id: (_k = device.additionalParams) === null || _k === void 0 ? void 0 : _k.frequencyPlanId,
                supports_class_c: false,
                supports_class_b: false,
                mac_settings: {
                    rx2_data_rate_index: 0,
                    rx2_frequency: "869525000",
                    rx1_data_rate_offset: 0,
                    rx1_delay: 1,
                    resets_f_cnt: true,
                    adr_margin: null,
                    use_adr: null,
                    adr: {
                        dynamic: {
                            margin: 16,
                        },
                    },
                },
                session: {
                    //@ts-ignore
                    dev_addr: (_l = device.additionalParams) === null || _l === void 0 ? void 0 : _l.deviceEUI.slice(8, 16),
                    keys: {
                        f_nwk_s_int_key: {
                            key: "430046937C03A083C7AED32A26EA001A",
                        },
                        s_nwk_s_int_key: {
                            key: "430046937C03A083C7AED32A26EA001A",
                        },
                        nwk_s_enc_key: {
                            key: "430046937C03A083C7AED32A26EA001A",
                        },
                    },
                },
            },
            field_mask: {
                paths: [
                    "ids",
                    "ids.dev_eui",
                    "ids.device_id",
                    "supports_join",
                    "lorawan_version",
                    "frequency_plan_id",
                    "lorawan_phy_version",
                    "mac_settings.rx2_data_rate_index",
                    "mac_settings.rx2_frequency",
                    "mac_settings.rx1_data_rate_offset",
                    "mac_settings.rx1_delay",
                    "mac_settings.resets_f_cnt",
                    "mac_settings.adr_margin",
                    "mac_settings.use_adr",
                    "mac_settings.adr",
                    "mac_settings.adr_margin",
                    "session.dev_addr",
                    "session.keys.f_nwk_s_int_key.key",
                    "session.keys.s_nwk_s_int_key.key",
                    "session.keys.nwk_s_enc_key.key",
                ],
            },
        },
        applicationServer: {
            end_device: {
                session: {
                    keys: {
                        app_s_key: {
                            key: "92C9CC7F886ABA8EB6236279194424EA",
                        },
                    },
                },
            },
            field_mask: {
                paths: ["session.keys.app_s_key.key"],
            },
        },
    };
    return params;
}
//# sourceMappingURL=utils.js.map